import { getApiClient } from './api-client';

export type OrganizationRole = 'OWNER' | 'ADMIN' | 'MANAGER' | 'MEMBER';
export type MembershipStatus = 'ACTIVE' | 'PENDING' | 'SUSPENDED' | 'DISABLED';

export interface CurrentOrganization {
  id: string;
  name: string;
  slug: string;
  isActive: boolean;
  membership: {
    id: string;
    role: OrganizationRole;
    status: MembershipStatus;
  };
}

export interface OrganizationMember {
  id: string;
  username: string;
  role: OrganizationRole;
  status: MembershipStatus;
  lastLoginAt: string | null;
  createdAt: string;
  user: {
    id: string;
    firstName: string | null;
    lastName: string | null;
    fullName: string | null;
    email: string | null;
    imageUrl: string | null;
  };
}

export interface CreateOrganizationMemberRequest {
  username: string;
  password: string;
  role: OrganizationRole;
  firstName?: string;
  lastName?: string;
  email?: string;
}

export const organizationService = {
  updateCurrent(name: string) {
    return getApiClient().patch<CurrentOrganization>('/organizations/current', {
      name,
    });
  },
  listMembers() {
    return getApiClient().get<OrganizationMember[]>(
      '/organizations/current/members',
    );
  },
  createMember(request: CreateOrganizationMemberRequest) {
    return getApiClient().post<OrganizationMember>(
      '/organizations/current/members',
      request,
    );
  },
  updateMember(
    membershipId: string,
    request: Partial<{
      role: OrganizationRole;
      status: MembershipStatus;
      password: string;
    }>,
  ) {
    return getApiClient().patch<OrganizationMember>(
      `/organizations/current/members/${membershipId}`,
      request,
    );
  },
};
